import type { LanguageCode } from "@/shared/types/language.types"

import { SUPPORTED_LANGUAGES } from "../model/constants"

export const isSupportedLanguage = (lng: unknown): lng is LanguageCode =>
  typeof lng === "string" && (SUPPORTED_LANGUAGES as readonly string[]).includes(lng)
